import './App.css';
import Box from './Components/Box';
import Box1 from './Components/Box1';
import Footer from './Components/Footer';
import Header from './Components/Header';

function App() {
  return (
    <div className="h-[180rem] sm:h-[100rem] bg-[#f0f1f6] w-screen">
      <Header />
      <h2 className='text-3xl sm:left-[40%] sm:text-4xl sm:top-[54rem] absolute font-medium left-[3.20rem] top-[58rem]'>Advanced Statistics</h2>
      <p className='text-[rgb(140,140,149)] sm:hidden text-lg text-center absolute left-[2.60rem] top-[61rem] '>Track how your links are performing <br /> across the web with our advanced <br /> statistics dashboard.</p>
      <p className='text-[rgb(140,140,149)] sm:text-xl sm:top-[58rem] sm:left-[34%] text-[0px] text-center absolute left-[2.60rem] top-[61rem] '>Track how your links are performing  across the web with <br/> our advanced  statistics dashboard.</p>

      <Box />
      <Box1 />
      <Footer />
    </div>
  );
}

export default App;
